import { render, staticRenderFns } from "./SelectProducts.vue?vue&type=template&id=39560685&scoped=true"
import script from "./SelectProducts.vue?vue&type=script&lang=js"
export * from "./SelectProducts.vue?vue&type=script&lang=js"
import style0 from "./SelectProducts.vue?vue&type=style&index=0&id=39560685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39560685",
  null
  
)

export default component.exports